import { useSelect } from "@refinedev/antd";
import { ICustomer } from "interfaces";
import { APP_WRITE_CUSTOMER_ID } from "utility/constants";

export const CustomerSelectOptions = () => {
  const { selectProps: customerSelectProps } = useSelect<ICustomer>({
    resource: APP_WRITE_CUSTOMER_ID,
    optionLabel: "name",
    optionValue: "id",
    sorters: [
      {
        field: "name",
        order: "asc",
      },
    ],
  });
  return (
    {customerSelectProps}
  );
};